// 画像カルーセル（.js-carousel）。固定領域に 1 枚ずつ表示・無限ループ・スワイプ対応。
// 実体は共通エンジン（_carouselEngine.js）。ここは画像版の config を渡すだけ。
// 1 コマ＝ビューポート幅。画像タップの拡大は photoswipe.js（.js-pswp-container）に
// 委ね、ドラッグ時の拡大抑止は共通エンジン側で行う。

import { createCarousel } from './_carouselEngine';

export function carousel() {
  document.querySelectorAll('.js-carousel').forEach((root) => {
    // キャプションエリア内のキャプション（スライドと同じ並び）。表示中のスライドの分だけ見せる。
    const captions = root.querySelectorAll('.js-carousel-caption');
    createCarousel(root, {
      trackSelector: '.js-carousel-track',
      viewportSelector: '.carousel-viewport',
      prevSelector: '.js-carousel-prev',
      nextSelector: '.js-carousel-next',
      counterSelector: '.js-carousel-counter',
      // 1 コマ＝ビューポート幅（スライドは flex:0 0 100% でビューポート幅と一致）。
      measureStep: ({ root, viewport }) => (viewport || root).clientWidth,
      // クローンを PhotoSwipe のギャラリー対象から除外する。
      onClone: (clone) => {
        clone.classList.remove('js-pswp-element');
        clone.querySelectorAll('.js-pswp-open').forEach((a) => a.classList.remove('js-pswp-open'));
      },
      onChange: (index) => {
        captions.forEach((cap, i) => cap.classList.toggle('is-active', i === index));
      },
    });
  });
}
